export enum TransferRequestTypeEnum {
  BetweenInsigniaAccount = 'BetweenInsigniaAccount',
  OtherInsigniaAccount = 'OtherInsigniaAccount',
  OtherBankTransfer = 'OtherBankTransfer',
  CardAccountSettlement = 'CardAccountSettlement',
}
